module.exports = __webpack_public_path__ + "assets/closeMark-dab567.svg";